import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useEditCustomerDataMutation, useGetCustomerbyIdQuery } from "../../Services/CustomerAPI";
import { useNavigate } from "react-router-dom";

function CustomerInfoForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        billing_first_name: "",
        billing_last_name: "",
        billing_company_name: "",
        billing_country: "",
        billing_street_address: "",
        billing_town_city: "",
        billing_state: "",
        billing_pin_code: "",
        billing_phone: "",
        billing_email: "",
        shipping_first_name: "",
        shipping_last_name: "",
        shipping_company_name: "",
        shipping_country: "",
        shipping_street_address: "",
        shipping_town_city: "",
        shipping_state: "",
        shipping_pin_code: "",
        shipping_phone: "",
        user_id:""
    });

    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    const [updateCustomerInfo, { isLoading }] = useEditCustomerDataMutation();
    const { data, isLoading: contentLOading, error, refetch } = useGetCustomerbyIdQuery(id);

    console.log("data", data)

    useEffect(() => {
        setFormData({
            first_name: data?.data?.first_name || "",
            last_name: data?.data?.last_name || "",
            email: data?.data?.email,
            billing_first_name: data?.data?.billing_address?.[0]?.first_name,
            billing_last_name:  data?.data?.billing_address?.[0]?.last_name,
            billing_company_name:  data?.data?.billing_address?.[0]?.company_name,
            billing_country: data?.data?.billing_address?.[0]?.country,
            billing_street_address: data?.data?.billing_address?.[0]?.street_address,
            billing_town_city: data?.data?.billing_address?.[0]?.town_city,
            billing_state: data?.data?.billing_address?.[0]?.state,
            billing_pin_code: data?.data?.billing_address?.[0]?.pin_code,
            billing_phone: data?.data?.billing_address?.[0]?.pin_code,
            billing_email: data?.data?.billing_address?.[0]?.email,
            shipping_first_name: data?.data?.shipping_address?.[0]?.first_name,
            shipping_last_name: data?.data?.shipping_address?.[0]?.last_name,
            shipping_company_name: data?.data?.shipping_address?.[0]?.company_name,
            shipping_country: data?.data?.shipping_address?.[0]?.country,
            shipping_street_address: data?.data?.shipping_address?.[0]?.street_address,
            shipping_town_city: data?.data?.shipping_address?.[0]?.town_city,
            shipping_state: data?.data?.shipping_address?.[0]?.state,
            shipping_pin_code: data?.data?.shipping_address?.[0]?.pin_code,
            shipping_phone: data?.data?.shipping_address?.[0]?.phone,
            user_id:id
        });

    }, [data, id])
    //   const validateForm = () => {
    //     let newErrors = {};
    //     if (!formData.last_name.trim()) newErrors.last_name = "Last name is required";
    //     if (!formData.display_name.trim()) newErrors.display_name = "Display name is required";
    //     if (!formData.email.trim()) newErrors.email = "Email is required";
    //     if (!formData.billing_email.trim()) newErrors.billing_email = "Billing email is required";
    //     if (!formData.billing_phone.trim()) newErrors.billing_phone = "Billing phone is required";
    //     if (!formData.shipping_phone.trim()) newErrors.shipping_phone = "Shipping phone is required";
    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    //   };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (!validateForm()) return;

        try {
            await updateCustomerInfo(formData).unwrap();
            alert("Customer info updated successfully!");
            refetch();
            setFormData({
                last_name: "",
                email: "",
                billing_first_name: "",
                billing_last_name: "",
                billing_company_name: "",
                billing_country: "",
                billing_street_address: "",
                billing_town_city: "",
                billing_state: "",
                billing_pin_code: "",
                billing_phone: "",
                billing_email: "",
                shipping_first_name: "",
                shipping_last_name: "",
                shipping_company_name: "",
                shipping_country: "",
                shipping_street_address: "",
                shipping_town_city: "",
                shipping_state: "",
                shipping_pin_code: "",
                shipping_phone: "",
            });
            setErrors({});
            setApiError(null);
            navigate("/customer-list");
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    if (contentLOading) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Edit Customer Info</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/customer-list"><span>Customers</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Edit</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {/* Personal Details */}
                        <div className="col-md-6 mb-4">
                            <label className="form-label">First Name</label>
                            <input type="text" className="form-control" name="first_name" value={formData.first_name} onChange={handleInputChange} />
                            {errors.first_name && <p className="text-danger">{errors.first_name}</p>}
                        </div>
                        <div className="col-md-6 mb-4">
                            <label className="form-label">Last Name</label>
                            <input type="text" className="form-control" name="last_name" value={formData.last_name} onChange={handleInputChange} />
                            {errors.last_name && <p className="text-danger">{errors.last_name}</p>}
                        </div>
                        <div className="col-md-6 mb-4">
                            <label className="form-label">Email</label>
                            <input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} />
                            {errors.email && <p className="text-danger">{errors.email}</p>}
                        </div>
                    </div>

                    {/* Billing Details */}
                    <h4 className="mt-5 mb-4">Billing Information</h4>
                    <div className="row">
                        {["billing_first_name", "billing_last_name", "billing_company_name", "billing_country", "billing_street_address", "billing_town_city", "billing_state", "billing_pin_code", "billing_phone", "billing_email"].map((field) => (
                            <div className="col-md-6 mb-4" key={field}>
                                <label className="form-label">
                                    {field.replace("billing_", "").replace("_", " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
                                </label>

                                <input type="text" className="form-control" name={field} value={formData[field]} onChange={handleInputChange} />
                                {errors[field] && <p className="text-danger">{errors[field]}</p>}
                            </div>
                        ))}
                    </div>

                    {/* Shipping Details */}
                    <h4 className="mt-5 mb-4">Shipping Information</h4>
                    <div className="row">
                        {["shipping_first_name", "shipping_last_name", "shipping_company_name", "shipping_country", "shipping_street_address", "shipping_town_city", "shipping_state", "shipping_pin_code", "shipping_phone"].map((field) => (
                            <div className="col-md-6 mb-4" key={field}>
                                <label className="form-label">
                                    {field.replace("shipping_", "").replace("_", " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
                                </label>

                                <input type="text" className="form-control" name={field} value={formData[field]} onChange={handleInputChange} />
                                {errors[field] && <p className="text-danger">{errors[field]}</p>}
                            </div>
                        ))}
                    </div>

                    {apiError && <p className="text-danger text-center">{apiError}</p>}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default CustomerInfoForm;
